import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=3197c0f2&"
import script from "./SubTitle.vue?vue&type=script&lang=ts&"
export * from "./SubTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports